import MapContainer from './containers/MapContainer';

export default MapContainer;